import { useIntl } from 'react-intl';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useRangeSliderFilterConfig, { getValidRangeSliderValue } from './useRangeSliderFilterConfig';

const mValues = Array.from(Array(31).keys()).map(v => v * 150); // 0-4500, in 150 increments

const ftValues = Array.from(Array(31).keys()).map(v => v * 500); // 0-15000, in 500 increments;

export const getValidHighestPoint = (meters: number, useMetric: boolean) =>
  getValidRangeSliderValue(meters, ftValues, 'foot', mValues, 'meter', useMetric);

const useHighestPointFilterConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void,
  useMetric: boolean
) => {
  const intl = useIntl();

  return useRangeSliderFilterConfig(
    exploreServiceFilters,
    onFiltersChange,
    'highestPoint',
    intl.formatMessage({ defaultMessage: 'Highest point' }),
    ftValues,
    'foot',
    mValues,
    'meter',
    useMetric
  );
};

export default useHighestPointFilterConfig;
